import { createIcon } from '@chakra-ui/react';
export const Minus = createIcon({
    displayName: 'Minus',
    viewBox: '0 0 10 2',
    d: 'M0.625 1.75C0.625 1.28516 1.00781 0.875 1.5 0.875H8.5C8.96484 0.875 9.375 1.28516 9.375 1.75C9.375 2.24219 8.96484 2.625 8.5 2.625H1.5C1.00781 2.625 0.625 2.24219 0.625 1.75Z',
});
//# sourceMappingURL=minus.js.map